require('./angular-idle');
module.exports = 'ngIdle';



//////////////////
// WEBPACK FOOTER
// ./~/ng-idle/index.js
// module id = 340
// module chunks = 0